import { Spinner } from '~/shared/ui/Spinner/Spinner';

import { Root, SpinnerWrapper } from './SbpButton.ui';

type SbpButtonProps = React.ComponentPropsWithoutRef<'button'> & {
  children?: React.ReactNode;
  isLoading?: boolean;
  buttonType?: 'primary' | 'secondary';
};

export const SbpButton = (props: SbpButtonProps) => {
  const {
    children,
    disabled = false,
    isLoading = false,
    buttonType = 'primary',
    onClick,
    ...otherProps
  } = props;
  const isInteractionBlocked = disabled || isLoading;

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    if (isLoading) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    onClick?.(event);
  };

  const renderContent = () => {
    if (isLoading) {
      return (
        <SpinnerWrapper>
          <Spinner />
        </SpinnerWrapper>
      );
    }

    return children;
  };

  return (
    <Root
      {...otherProps}
      disabled={disabled}
      buttonType={buttonType}
      isLoading={isLoading}
      onClick={handleClick}
      tabIndex={isInteractionBlocked ? -1 : 0}
    >
      {renderContent()}
    </Root>
  );
};
